import React, { memo } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { colorsNew } from 'root/src/client/web/commonStyles'
import { styledPledgeButton } from './style'

const Button = memo(({ classes, title, backgroundColor, color }) => (
	<button className={classes.button} type="button" style={{ backgroundColor, color }}>{title}</button>
))

Button.defaultProps = {
	backgroundColor: colorsNew.dark2,
	color: '#fff',
}

export default withStyles(styledPledgeButton, { name: 'MuiPledgeButton' })(Button)
